/// <amd-module name="VSSUI/Components/Tooltip/Tooltip" />

import * as React from "react";
import { css } from "VSSUI/Util";
import { Tooltip as OfTooltip, ITooltipProps } from "OfficeFabric/Tooltip";

/** @deprecated Please use import { TooltipEx } from "VSSUI/TooltipEx"*/
export class Tooltip extends React.Component<ITooltipProps> {
    public render() {
        const realProps: ITooltipProps = { ...this.props };

        if (!realProps.calloutProps) {
            realProps.calloutProps = {
                isBeakVisible: false
            };
        }

        if (!realProps.calloutProps.gapSpace) {
            realProps.calloutProps.gapSpace = 8;
        }

        return <OfTooltip {...realProps} className={css(realProps.className || realProps.calloutProps.className, "vss-Tooltip")} />;
    }
}
